import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QueovalDateTime, Select } from '../models';
import { Historique, HistoriqueModel, HistoryMode } from '../models/historique/historique.model';
import { CoreService, HttpService } from '../services';
import { ToastService } from '../toast';
import { HistoryService } from './history.service';

@Component({
  selector: 'q-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})


/**
 * Composant pour l'historique
 */
export class HistoryComponent implements OnInit {

  //#region propriétés publiques

  /**
   * Mode d'historique (pour savoir quel type utiliser)
   */
  public type: string;

  /**
   * taille du composant
   */
  /*public height: string = '500px';*/
  /**
   * Ident pere de l'historique
   */
  public idPere: string;

  public NameCollaboConnected: string;
  public LogoCollaboConnected: string = '';

  public HistoryNewComment: string = '';

  public HistoryBoTypeValue: string = '';
  public HistoryBoTypes: Array<Select> = new Array<Select>();
  public maxCommentLength: number;

  public emptyComment: boolean = false;

  // Idents supplémentaires liés à l'historique
  public idContact: string;
  public idClient: string;

  // spécifique mode STAGE
  public ListContacts: Array<Select> = new Array<Select>();

  // booleen pour l'affichage des loader
  public histoIsSaving: boolean = false;

  // Constantes modes d'historique
  public HistoryMode = HistoryMode;

  public isLoading: boolean;

  public selectedHistory: Historique;

  //#endregion


  //#region input / output

  /**
   * Liste des types existants actuellement :
   * ACTIONCO
   * STAGE
   */
  @Input('Type') set SetType(value: string) {
    this.type = value;
    this.GetTypeHisto();
    this.getInitFromId();
  }

  /**
   * Ident sur lequel est lié l'historique (idpere)
   * identActionCo
   * identStage
   */
  @Input('Ident') set SetIdPere(value: string) {
    this.idPere = value;
    this.getInitFromId();
    this.historyService.GetHistory(this.idPere).subscribe();
  }

  //@Input('height') set SetHeight(value: string) {
  //  this.height = value;
  //}
  @Output() sendHistory: EventEmitter<Array<Historique>> = new EventEmitter<Array<Historique>>();


  @ViewChild('histoDetailmodal') histoDetailmodal: ElementRef;
  //#endregion

  //#region Constructeur
  constructor(
    public indParam: CoreService,
    protected domSanitizer: DomSanitizer,
    protected http: HttpService,
    protected toast: ToastService,
    public historyService: HistoryService,
    protected modalService: NgbModal,

  ) { }

  //#endregion

  ngOnInit(): void {
    // Récupération de la personne connectée + son logo
    this.NameCollaboConnected = `${this.indParam.AppParams.LoggedUser.NomfaPER} ${this.indParam.AppParams.LoggedUser.Pre01PER}`;
    this.http.getHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/GET_LOGO_COLLABO/${this.indParam.AppParams.LoggedUser.Ident}/`).subscribe(
      (data: HistoriqueModel) => {
        this.LogoCollaboConnected = data.LogoCollaboConnected;
      });
  }


  //#region public function
  public getUrl(url: string): string {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url) as string;
  }

  /**
   * Augmente automatiquement le taille du textearea "Nouveau commentaire"
   * @param oField
   */
  public TexteareaAutoGrow(oField: any): void {
    if (oField.currentTarget != null) {
      const target: any = oField.currentTarget;
      target.style.height = '1px';
      target.style.height = target.scrollHeight + "px";
    }
  }

  /**
   * Récupération des données initiales à partir de l'ident fourni en input
   */
  public getInitFromId(): void {
    if (this.idPere && this.type) {
      // Récupération des informations uniquement si l'ident + le mode sont récupérés

      this.http.getHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/INIT_${this.type}/${this.idPere}/`).subscribe(
        (data: HistoriqueModel) => {
          // Récupération des données selon le mode
          switch (this.type) {
            case 'ACTIONCO':
              this.idContact = data.IdContactPrincipal;
              this.idClient = data.IdClient;
              break;
            case 'STAGE':
              this.ListContacts = data.ListContact;
              this.idContact = '0';
              break;
            default:
              break;
          }
        });
    }

  }

  public GetTypeHisto(): void {
    this.http.getHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/GET_TYPE_HISTO/${this.type}/`).subscribe(
      (data: HistoriqueModel) => {
        this.HistoryBoTypeValue = data.BoTypeValue;
        this.HistoryBoTypes = data.BoTypes;
        this.maxCommentLength = data.MaxLengthValue;
      });
      
  }

  public SetCommentTemplate(history: Historique, template: string): void {
    history.CommentTemplate = !history.CommentTemplate || history.CommentTemplate !== template ? template : '';
  }

  public openHistoModal(pHistory: Historique): void {
    this.selectedHistory = pHistory;
    this.modalService.open(this.histoDetailmodal, { centered: true, size: 'lg', windowClass: 'qmodalover' });
  }

  public CloseHistoModal() {
    if (this.modalService) {
      this.modalService.dismissAll();
    }
  }

  public SaveComment(): void {
    //fait remonter le nom  du contact si un contact a été sélectionné
    let nameContact: string = "";
    if (this.idContact && this.idContact != '0' && this.type == 'STAGE') {
      this.ListContacts.filter(contact => {
        if (contact.id == this.idContact) {
          nameContact = contact.value;
        }
      })
      
      //this.HistoryNewComment += `<br><p><small><strong>pour ${nameContact}</strong></small></p>`;
    }
    // Test si le commentaire ne dépasse pas la taille limite
    if (this.maxCommentLength > 0 && this.HistoryNewComment.length > this.maxCommentLength) {
      this.toast.showAlertToast(`Le texte du commentaire ne doit pas dépasser ${this.maxCommentLength} caractères`);
    }
    else {
      const model: HistoriqueModel = new HistoriqueModel();
      model.Mode = "SET_HISTORY";
      model.pageSize = this.historyService.pageSize;
      model.pageIndex = this.historyService.pageIndex;
      model.Type = this.type;
      model.IdPere = this.idPere;
      model.IdClient = this.idClient;
      model.IdContactPrincipal = this.idContact;
      model.SelectedHistory = new Historique();   
      model.SelectedHistory.Value = this.HistoryNewComment;
      model.SelectedHistory.BoTypeValue = this.HistoryBoTypeValue;
      const dateNow: Date = new Date();
      const annee: string = dateNow.getFullYear().toString();
      const mois: string = (dateNow.getMonth() + 1).toString();
      const jour: string = dateNow.getDate().toString();
      const heures: number = dateNow.getHours();
      const minutes: number = dateNow.getMinutes();
      const sec: number = dateNow.getSeconds();
      model.SelectedHistory.Date = new QueovalDateTime(annee, mois, jour, heures.toString(), minutes.toString(), sec.toString());

      this.indParam.showSplash(true);
      this.http.postHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/`, model).subscribe(
        (data: HistoriqueModel) => {
          if (!data.HasError) {
            this.toast.showSuccessToast('Historique enregistré');
            this.indParam.showSplash(false);
            // Mise à jour de la liste des historiques
            this.historyService.ListHistories = data.ListHistories;
            this.historyService.pageLength = data.pageLength;
            // Rémise à zéro du commentaire
            this.HistoryNewComment = '';

            // envoi de la liste dans l'emiter
            this.sendHistory.emit(data.ListHistories);
          }
        });
    }
  }

  public DeleteHistory(history: Historique): void {
    this.histoIsSaving = true;
    const model: HistoriqueModel = new HistoriqueModel();
    model.Mode = "DELETE_HISTORY";
    model.SelectedHistory = history;    
    model.IdPere = this.idPere;
    model.Type = this.type;
    this.http.postHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/`, model).subscribe(
      () => {
        // retrait de l'historique dans la liste
        this.historyService.ListHistories.splice(this.historyService.ListHistories.indexOf(history), 1);
        this.historyService.ListHistories = JSON.parse(JSON.stringify(this.historyService.ListHistories));
        // envoi de la liste dans l'emiter
        this.sendHistory.emit(this.historyService.ListHistories);
        this.histoIsSaving = false;
        history.CommentTemplate = '';
      });
  }

  public UpdateHistory(history: Historique, type: string): void {
    history.BoTypeValue = type;
    const model: HistoriqueModel = new HistoriqueModel();
    model.Mode = "SET_HISTORY_TYPE";
    // Changement dynamique du type
    let boTypeText = history.BoTypes.find(t => t.id === type)?.value;
    if (boTypeText) {
      history.BoTypeText = boTypeText;
    }
    model.SelectedHistory = history;
    history.CommentTemplate = '';
    this.http.postHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/`, model).subscribe(
      () => {
        // envoi de la liste dans l'emiter
        this.sendHistory.emit(this.historyService.ListHistories);
      });
  }

  public SaveReply(comment: HTMLTextAreaElement, history: Historique): void {
    this.histoIsSaving = true;
    const model: HistoriqueModel = new HistoriqueModel();
    model.Mode = "SET_HISTORY_REPLY";
    model.SelectedHistory = history;
    model.SelectedHistory.NewResponse = comment.value;
    // ajout dynamique de la réponse
   // history.Responses.push();
    this.http.postHttp<HistoriqueModel>(`${this.indParam.AppParams.apiUrl}api/History/`, model).subscribe(
      (data: HistoriqueModel) => {
        history.Responses = data.SelectedHistory.Responses;
        // envoi de la liste dans l'emiter
        this.sendHistory.emit(this.historyService.ListHistories);
        comment.value = '';
        history.CommentTemplate = '';
        this.histoIsSaving = false;
      });
  }

  //#enregion

  public GetLastPageIndex(): number {
    return Math.ceil(this.historyService.pageLength / this.historyService.pageSize) - 1;
  }

  public GetHistory(): void {
    this.historyService.GetHistory(this.idPere).subscribe();
  }
}


